import gql from 'graphql-tag';

export const UPDATE_TRAFFICKING_CUSTOM_FILTER = gql`
  mutation UPDATE_TRAFFICKING_CUSTOM_FILTER($id: ID!, $input: UpdateTraffickingCustomFilterInput!) {
    updateTraffickingCustomFilter(id: $id, input: $input) {
      id
      filterName
      filterType
      visibility
      createdBy
    }
  }
`;
